import React from "react";
import ProfileView from "./ProfileView";

export function ProfileContainer() {
  return <ProfileView title="Profile" />;
}
